import { render, staticRenderFns } from "./ReintegroDettaglio.vue?vue&type=template&id=27b2434a"
import script from "./ReintegroDettaglio.vue?vue&type=script&lang=ts"
export * from "./ReintegroDettaglio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27b2434a')) {
      api.createRecord('27b2434a', component.options)
    } else {
      api.reload('27b2434a', component.options)
    }
    module.hot.accept("./ReintegroDettaglio.vue?vue&type=template&id=27b2434a", function () {
      api.rerender('27b2434a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReintegroDettaglio.vue"
export default component.exports